import { Typography } from 'UI';
import { getTransition } from 'styles/useTransition';
import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { FONT_WEIGHT, TextColor, TEXT_COLOR } from 'styles/constants';
import { IWeightAnswer } from 'modules/survey/helpers';

interface Props {
	value?: string;
	onClick?: (value?: string, weightAnswer?: IWeightAnswer) => void;
	label?: string;
	backgroundColor?: string;
	backgroundColorHover?: string;
	backgroundColorSelected?: string;
	labelColor?: string | TextColor;
	labelColorSelected?: string | TextColor;
	labelSize?: number;
	labelWeight?: number | FONT_WEIGHT;
	selected?: boolean;
	height?: number;
	borderRadius?: number;
	weightAnswer?: IWeightAnswer;
}

const StyledItem = styled.button<Props & { children: React.ReactNode }>`
	width: 100%;
	height: ${({ height }) => height ?? 40}px;
	cursor: pointer;
	text-align: center;
	background: ${({ theme, backgroundColor }) => backgroundColor ?? theme.colors.bg2 ?? '#f3f2f9'};
	border-radius: ${({ borderRadius }) => (borderRadius ? `${borderRadius}px` : '0')};
	${({ theme }) => getTransition(theme.durations.ms300, 'all')}

	${({ selected }) =>
		selected &&
		css<Props>`
			background: ${({ theme, backgroundColorSelected }) =>
				backgroundColorSelected ??
				theme.colors.primaryGradient4 ??
				'linear-gradient(225deg,#7652b2,#605c98)'};
		`}

	&:not(:active):hover {
		background-color: ${({ backgroundColorHover, theme }) =>
			backgroundColorHover ?? theme.colors.bg3 ?? '#e8e6f5'};
	}
`;

export const Item: FC<Props> = props => {
	const {
		label,
		labelSize = 17,
		labelColor = TEXT_COLOR.TEXT5,
		labelColorSelected = 'white',
		labelWeight = FONT_WEIGHT.BOLD,
		selected,
		value,
		weightAnswer,
		onClick,
	} = props;

	const handleClick = (value?: string, weightAnswer?: IWeightAnswer): void => {
		onClick?.(value, weightAnswer);
	};

	return (
		<StyledItem {...props} onClick={() => handleClick(value, weightAnswer)}>
			<Typography
				size={labelSize}
				weight={labelWeight}
				color={selected ? labelColorSelected : labelColor}
			>
				{label}
			</Typography>
		</StyledItem>
	);
};
